let language = {
    "LBL_HOME":"Home",
    "LBL_CREATE_VIEW": "Create View",
    "LBL_DETAIL_VIEW": "Detail View",
    "LBL_EDIT_VIEW": "Edit View",
    "LBL_ADD_REMINDER": "Create Reminder",
    "LBL_VIEW_REMINDER": "View Reminder",
    "LBL_REMINDER_NAME": "Reminder Name",
    "LBL_CREATED_BY": "Created By",
    "LBL_PARENT_ID": "Parent ID",
    "LBL_REMINDER_TYPE": "Reminder Type",
    "LBL_REMINDER_TIME": "Reminder Time",
    "LBL_REMINDER_DATE": "Reminder Date",
    "LBL_USERS": "Users",
    "LBL_PARENT_TYPE": "Parent Type",
    "LBL_DESCRIPTION":"Description",
    "LBL_CREATE_DATE":"Date Created",
    "LBL_ENTERED":"Date Entered",
    "LBL_MODIFIED_DATE":"Date Modified",
    "LBL_DOWNLOAD_ONE":"Download 1",
    "LBL_DOWNLOAD_TWO":"Download 2",
    "LBL_EDIT":"Edit",
    "LBL_DELETE":"Delete",
}

export default language;